export default {
  state: {
    adminDebtor: {},
  },
  mutations: {
    SET_ADMIN_DEBTOR(state, payload) {
      state.adminDebtor = payload.debtor;
    },
    UPDATE_ADMIN_DEBTOR(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
    DELETE_ADMIN_DEBTOR(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
    RESTORE_ADMIN_DEBTOR(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
  },
  actions: {
    async GET_ADMIN_DEBTOR({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/admin/debtors/${payload}`);
        commit('SET_ADMIN_DEBTOR', data);
      } catch (err) {
        throw err;
      }
    },
    async UPDATE_ADMIN_DEBTOR({ commit }, payload) {
      try {
        const { id } = payload;
        const { data } = await window.axios.put(`/admin/debtors/${id}`, payload);
        commit('UPDATE_ADMIN_DEBTOR', data);
      } catch (err) {
        throw err;
      }
    },
    async DELETE_ADMIN_DEBTOR({ commit }, payload) {
      try {
        const { data } = await window.axios.delete(`/admin/debtors/${payload}`);
        commit('DELETE_ADMIN_DEBTOR', data);
      } catch (err) {
        throw err;
      }
    },
    async RESTORE_ADMIN_DEBTOR({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/admin/debtors/${payload}/restore`);
        commit('RESTORE_ADMIN_DEBTOR', data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    adminDebtor(state) {
      return state.adminDebtor;
    },
  },
};
